module.exports = __webpack_public_path__ + "img/KinokoTable21.bd0bf122.jpg";